import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=9bd31042&"
import script from "./breadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./breadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./breadcrumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports